var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16356_108680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 2.66406C12.1012 2.66406 12.2003 2.68673 12.2907 2.73036C12.3811 2.774 12.4604 2.83747 12.5229 2.91606L12.5722 2.98806L14.5722 6.3214C14.6377 6.4307 14.6705 6.55648 14.6667 6.68385C14.6629 6.81122 14.6227 6.93484 14.5509 7.04006L14.4975 7.10873L8.81086 13.4641C8.70526 13.5718 8.57923 13.6574 8.44014 13.7157C8.30105 13.7741 8.1517 13.8041 8.00086 13.8041C7.73419 13.8041 7.47752 13.7107 7.26086 13.5261L7.17086 13.4421L1.50419 7.10873C1.41894 7.01361 1.36281 6.89599 1.34248 6.76989C1.32215 6.64378 1.33848 6.51449 1.38952 6.3974L1.42952 6.32073L3.43819 2.97273L3.48086 2.91273C3.51137 2.87477 3.54603 2.84033 3.58419 2.81006L3.64352 2.7674L3.70219 2.73406L3.73552 2.71873L3.77552 2.70206L3.84819 2.68073L3.92286 2.6674L4.00086 2.66406H12.0009ZM6.07686 5.29273C5.9253 5.20197 5.74392 5.17507 5.57254 5.21795C5.40117 5.26082 5.25382 5.36996 5.16286 5.5214L4.76286 6.18806L4.72286 6.2654C4.67183 6.38305 4.65582 6.51293 4.67675 6.63945C4.69768 6.76597 4.75466 6.88377 4.84086 6.97873L6.17419 8.4454L6.23419 8.50406C6.3576 8.60966 6.51531 8.66658 6.67771 8.66412C6.84011 8.66167 6.99603 8.60001 7.11619 8.49073L7.17419 8.43073C7.27979 8.30732 7.33671 8.14961 7.33425 7.98721C7.3318 7.82481 7.27014 7.66889 7.16086 7.54873L6.16019 6.44873L6.30552 6.20673L6.34219 6.13806C6.40918 5.98912 6.41917 5.82076 6.37026 5.66494C6.32135 5.50912 6.21695 5.37667 6.07686 5.29273Z",
    fill: "#E08701"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16356_108680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProFeature);
export default __webpack_public_path__ + "static/media/ProFeature.b3b5d3e01598217df374f40b9f8eca0f.svg";
export { ForwardRef as ReactComponent };